module.exports = __webpack_public_path__ + "static/media/icon-error.fd99901c.svg";